export enum ApiErrorCode {
  CONDITIONAL_CHECK_FAILED = "ConditionalCheckFailed",
}
